import { render, staticRenderFns } from "./LowestFares.vue?vue&type=template&id=725db420&scoped=true&"
import script from "./LowestFares.vue?vue&type=script&lang=js&"
export * from "./LowestFares.vue?vue&type=script&lang=js&"
import style0 from "./LowestFares.vue?vue&type=style&index=0&id=725db420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725db420",
  null
  
)

export default component.exports